import React from "react";
import Button from "@amzn/meridian/button";
import Row from "@amzn/meridian/row";

import { StaffingMode } from "../types";

import "./StaffingModeToggle.scss";

export interface StaffingModeToggleProps {
  mode: StaffingMode;
  onChange: (mode: StaffingMode) => void;
}

const StaffingModeToggle: React.FC<StaffingModeToggleProps> = ({ mode, onChange }) => {
  return (
    <Row spacing="none" className="staffing-mode-toggle">
      <Button
        type={mode === "PROCESS_LINES" ? "primary" : "tertiary"}
        size="small"
        onClick={() => onChange("PROCESS_LINES")}
      >
        Process lines
      </Button>
      <Button
        type={mode === "DEPARTMENT" ? "primary" : "tertiary"}
        size="small"
        onClick={() => onChange("DEPARTMENT")}
      >
        Individual
      </Button>
    </Row>
  );
};

export default StaffingModeToggle;

import './StaffingModeToggle.scss';